export const SAVED_VIEWS_TYPES = {
  custom: 'custom',
  system: 'system'
}
